import React from 'react'
import {
  Box,
  Text
} from 'grommet'

export default function ContactList() {
  return (
    <Box>
      <Text>Contact List</Text>
    </Box>
  )
}